export const onlyContainsNumbers = (value: string) => /^\d+$/.test(value)

export const includesExactPattern = (string: string, pattern: string) =>
  new RegExp(`\\b${pattern}\\b`, 'i').test(string)
